// extracted by mini-css-extract-plugin
module.exports = {"menu":"MoreOptions_menu__GIqXb","settings":"MoreOptions_settings__c8Z8W"};